import { apiRequest } from './api';
import { PlanosGrupo, ApiResponse } from '../types';

export const planosGruposService = {
  getAll: async (): Promise<ApiResponse<PlanosGrupo[]>> => {
    return apiRequest.get<PlanosGrupo[]>('/planos-grupos');
  },

  create: async (data: { titulo: string }): Promise<ApiResponse<PlanosGrupo>> => {
    return apiRequest.post<PlanosGrupo>('/planos-grupos', data);
  },

  update: async (id: number, data: { titulo: string }): Promise<ApiResponse<PlanosGrupo>> => {
    return apiRequest.put<PlanosGrupo>(`/planos-grupos/${id}`, data);
  },

  delete: async (id: number): Promise<ApiResponse<void>> => {
    return apiRequest.delete(`/planos-grupos/${id}`);
  },
};
